import { render, staticRenderFns } from "./AddToCurrentGroup.vue?vue&type=template&id=f741dfb6&scoped=true"
import script from "./AddToCurrentGroup.vue?vue&type=script&lang=js"
export * from "./AddToCurrentGroup.vue?vue&type=script&lang=js"
import style0 from "./AddToCurrentGroup.vue?vue&type=style&index=0&id=f741dfb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f741dfb6",
  null
  
)

export default component.exports